export class CompanySimpleListItem {
    id: string;
    name: string;
    policyId: string;
}